import { fetchApi } from '../settings.js';

export const API_getCustomer = async data => {
  try {
    const res = await fetchApi('/customers', {
      method: 'GET',
      query: { ...data },
    });

    if (res.ok) {
      const customer = await res.json();
      return customer;
    }
    return { customer: null };
  } catch (err) {
    console.error('Phone verify request failed', err);
    return { customer: null };
  }
};
